module.exports = __webpack_public_path__ + "img/arrow-left-right.0d5709eb.svg";